import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractObjectUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimUpdateWorkOrderObjectGql } from '../../bimWorkOrderQueries';

const requestId = 'bimUpdateWorkOrderObject';

export const useBimUpdateWorkOrderObject = (workOrderId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [bimUpdateWorkOrderObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        bimUpdateWorkOrderObjectReset(undefined);
        onSuccess?.();
    }, [bimUpdateWorkOrderObjectReset, onSuccess]);

    const [
        bimUpdateWorkOrderObjectData,
        bimUpdateWorkOrderObjectStatus,
        bimUpdateWorkOrderObjectError,
        bimUpdateWorkOrderObjectRequest,
    ] = useRequest({
        requestId,
        query: bimUpdateWorkOrderObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const bimUpdateWorkOrderObjectMakeRequest = useCallback(
        (input: BimContractObjectUpdateInput) => {
            dispatch(bimUpdateWorkOrderObjectRequest({ workOrderId, input }));
        },
        [bimUpdateWorkOrderObjectRequest, dispatch, workOrderId],
    );

    useEffect(() => {
        bimUpdateWorkOrderObjectReset(undefined);
    }, [bimUpdateWorkOrderObjectReset]);

    return {
        bimUpdateWorkOrderObjectData,
        bimUpdateWorkOrderObjectStatus,
        bimUpdateWorkOrderObjectError,
        bimUpdateWorkOrderObjectMakeRequest,
    };
};
